import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetImportableTemplateResData } from "./GetImportableTemplateResData";

const ENDPOINT = "/security/installation/template";

export class GetImportableTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetImportableTemplateReqData = null;

    constructor(params: GetImportableTemplateReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<GetImportableTemplateResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetImportableTemplateResData(res);
    }
}

export class GetImportableTemplateReqData {
    installationName: string;
    templateContent: TemplateContentEnum;
}
